import React from 'react';
import MarketingText from 'core/modules/MarketingText/MarketingText';
import SimpleBannerList from 'core/modules/SimpleBannerList/SimpleBannerList';
import FeaturedOffers502x272 from 'core/modules/FeaturedOffers502x272/FeaturedOffers502x272';
import FeaturedOffers150x150 from 'core/modules/FeaturedOffers150x150/FeaturedOffers150x150';
import FeaturedOffers120x90 from 'core/modules/FeaturedOffers120x90/FeaturedOffers120x90';
import SponsoredOffers from 'core/modules/SponsoredOffers/SponsoredOffers';
import DynamicMerchants from 'core/modules/DynamicMerchants/DynamicMerchants';
import TabNavigation from 'core/modules/TabNavigation/TabNavigation';
import OfferTable from 'core/modules/OfferTable/OfferTable';
import HtmlText from 'core/modules/HtmlText/HtmlText';
import BonusOffersFlexPage from 'core/modules/BonusOffersFlexPage/BonusOffersFlexPage';
import FeaturedInstoreOffers from 'core/modules/Instore2/components/FeaturedInstoreOffers/FeaturedInstoreOffers';
import ProductList from 'core/modules/ProductList/ProductList';
import DynamicExpiredPage from 'core/modules/DynamicExpiredPage/DynamicExpiredPage';
import DynamicPageForFuture from 'core/modules/DynamicPageForFuture/DynamicPageForFuture';

const DynamicPageComponent = ({ components, shouldShowAutomaticPublicBonus }) => (
  <div className="mn_dynamicPageContentComponents">
    {components?.map(({ id, type, properties }) => {
      const groupNameProperty = properties.find(prop => prop.name === 'group_name');

      const excludedTypes = [
        'instore_ad_module',
        'bonus_special_offer_text',
        'page_expired_text',
        'page_planned_text',
        'curated_products',
        'html_text',
        'tab_navigation',
      ];

      if (!excludedTypes.includes(type) && !groupNameProperty?.value) {
        return null;
      }

      const attributes = properties.reduce((obj, item) => {
        obj[item.name] = item.value;
        return obj;
      }, {});

      const { content_group_id, title } = attributes || {};

      const dynamicConfig = {
        api: { offers: { params: { content_group_id } } },
        getStaticTitle: () => title,
      };

      /* switch case for component name based on properties */
      /* eslint-disable camelcase */
      const componentMap = {
        marketing_text: <MarketingText key={id} namespace={id} {...attributes} />,
        simple_banner: !shouldShowAutomaticPublicBonus && <SimpleBannerList key={id} namespace={id} {...attributes} />,
        featured_460x250: <FeaturedOffers502x272 key={id} namespace={id} {...attributes} />,
        merchant_logo_120x60: <DynamicMerchants key={id} namespace={id} {...attributes} />,
        featured_products_150x150: <FeaturedOffers150x150 key={id} namespace={id} {...attributes} />,
        text_offer_sponsored: <SponsoredOffers key={id} namespace={id} {...attributes} />,
        promo_120x90: <FeaturedOffers120x90 key={id} namespace={id} {...attributes} />,
        tab_navigation: <TabNavigation key={id} namespace={id} {...attributes} />,
        html_text: <HtmlText key={id} namespace={id} {...attributes} />,
        text_offer_listings: <OfferTable key={id} namespace={id} {...attributes} />,
        bonus_special_offer_text: attributes.title && <BonusOffersFlexPage key={id} namespace={id} {...attributes} />,
        instore_ad_module: <FeaturedInstoreOffers key={id} namespace={id} customConfig={dynamicConfig} />,
        curated_products: <ProductList key={id} namespace={id} {...attributes} />,
        page_expired_text: <DynamicExpiredPage key={id} namespace={id} {...attributes} />,
        page_planned_text: <DynamicPageForFuture key={id} namespace={id} {...attributes} />,
      };
      /* eslint-enable camelcase */

      return componentMap[type] || null;
    })}
  </div>
);

export default DynamicPageComponent;
